import { DebitsTableColumnsIntl } from 'types/i18n';

export const debitsTableColumnsIntl: DebitsTableColumnsIntl = {
  id: 'id',
  clientName: 'Клиент',
  amount: 'Сумма, $',
  createdAt: 'Дата создания',
};
